module.exports = __webpack_public_path__ + "static/media/logoNegro.6e3e1423.png";